import React from 'react'

import {
  LINKED_METRIC_PREVIEW_HEIGHT,
  METRIC_PREVIEW_HEIGHT,
  MetricPreviewProps
} from '.'

import Skeleton from 'components_new/atoms/Skeleton'

const Loading = React.memo((props: MetricPreviewProps) => {
  const { disableBorderRadius, linked, sx } = props

  return (
    <Skeleton
      height={linked ? LINKED_METRIC_PREVIEW_HEIGHT : METRIC_PREVIEW_HEIGHT}
      sx={sx}
      variant={disableBorderRadius ? 'rectangular' : 'rounded'}
    />
  )
})

export default Loading
